


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
// import Lottie from 'lottie-react';
// import front from '../Animations/front.json';
import { Menu, X } from "lucide-react";
import logo from '../assets/login.png';
import bg from "../assets/fitofyy_logo.png";


const KidsZonePro = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); 
  const msisdn = Cookies.get('fitofyy_user');
  
  useEffect(() => {
    if (msisdn) {
      navigate('/');
    } else {
      axios.get('/getheaders')
        .then(response => {
          const data = response.data;
          if (data.status == '1') {
            Cookies.set('fitofyy_user', data.msisdn, { expires: 1 });
            Cookies.set('status', data.status, { expires: 1 });
            navigate('/');
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    }
  }, [msisdn, navigate]);

  const handleSubscribe = () => {
    window.location.href = "http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3Ddw%3D%3D";
  };

  const translations = {
    en: {
        title: "FITOFYY",
              subtitle: "Fitness and Wellness",
              subscribeInfo1: "Subscribe to Fitofyy service",
              subscribeInfo2: "You will be charged Rs. 6+tax per day",
              subscribe: "Subscribe",
      menuTerms: "Terms & Conditions",
      menuSubscribe: "Subscribe",
    },
    si: {
        title: "FITOFYY",
      subtitle: "මනාසික සහ ශාරීරික යෝග්‍යතාව",
      subscribeInfo1: "Fitofyy සේවාවට දායක වන්න",
      subscribeInfo2: "ඔබට Rs. 6+බදු/දිනකට අය වේ",
      subscribe: "සක්‍රිය\u00a0කරන්න",
      menuTerms: "නියම සහ කොන්දේසි",
      menuSubscribe: "සක්‍රිය කරන්න",
    },
    ta: {
           title: "FITOFYY",
      subtitle: "உடல் மற்றும் மன நலம்",
      subscribeInfo1: "Fitofyy சேவைக்கு பதிவு செய்யவும்",
      subscribeInfo2: "உங்களிடம் ரூ. 6+வரி/நாள் அறவிடப்படும்",
      subscribe: "செயல்படுத்து",
      menuTerms: "விதிமுறைகள் & நிபந்தனைகள்",
      menuSubscribe: "செயல்படுத்து",
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <header className="flex items-center justify-between p-4 bg-black shadow-lg relative z-50">
        <div className="flex items-center space-x-2">
          <img src={bg} alt="KidsZone Logo" className="h-10 w-auto" />
        </div>
        <div className="flex space-x-2">
          {Object.keys(translations).map(lang => (
            <button 
              key={lang}
              className={`px-3 py-1 rounded-lg text-sm font-semibold ${selectedLanguage === lang ? 'bg-orange-500 text-white' : 'bg-gray-300 text-black'}`}
              onClick={() => setSelectedLanguage(lang)}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>
        <div className="relative">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-white focus:outline-none">
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
          {menuOpen && (
            <div className="absolute top-12 right-4 bg-white text-black w-48 rounded-lg shadow-lg z-50 transition-all ease-in-out">
              <ul className="py-2">
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-200" onClick={handleSubscribe}>
                  {translations[selectedLanguage].menuSubscribe}
                </li>
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-200" onClick={() => window.location.href = "https://hutch.lk/vterms/"}>
                  {translations[selectedLanguage].menuTerms}
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>


      <div className="flex justify-center p-10 w-full  ">
           <div className="flex bg-white shadow-lg rounded-lg p-10 flex-col sm:flex-row items-center gap-6">
            {/* Left Section - Animation Placeholder */}
            <div className="sm:w-[50%] flex justify-center">
             <img src={logo} className="w-[90%] rounded-lg" alt="Fitness" />
           </div>

           {/* Right Section - Text & Button */}
           <div className="sm:w-[50%] flex flex-col text-left space-y-4">
              <h1 className="text-yellow-600 text-4xl font-bold">{translations[selectedLanguage].title}</h1>
              <h2 className="text-lg text-gray-700">{translations[selectedLanguage].subtitle}</h2>
              <p className="text-gray-700 text-lg font-semibold">{translations[selectedLanguage].subscribeInfo1}</p>
              <p className="text-gray-600 text-md font-semibold">{translations[selectedLanguage].subscribeInfo2}</p>
             <button onClick={handleSubscribe} className="bg-orange-500 text-white px-6 py-3 rounded-lg text-lg font-bold shadow-lg hover:bg-orange-600 transition">                 {translations[selectedLanguage].subscribe}
             </button>
            </div>
          </div>
        </div>

      <div className="mt-1 bg-black container mx-auto p-6 rounded-lg shadow-lg max-w-3xl w-full">
        <h3 className="text-xl font-bold mb-4">Terms & Conditions</h3>
        <ul className="list-disc text-justify text-gray-300">
          <li>By clicking on subscribe, you agree to the following terms and conditions.</li>
          <li>If you are a new customer, you will have the service free for one day then you will be charged as per selected pack.</li>
          <li>Your subscription will be automatically renewed until you cancel or unsubscribe.</li>
          <li>You can unsubscribe any time through the site by clicking on 'My Account' then 'Deactivate'.</li>
          <li>You must be more than 18 years old to use this service.</li>
          <li>If you are less than 18 years old, you MUST receive permission from the authorized person who pays your bill.</li>
          <li>Standard data browsing costs will be applied.</li>
          <li>For support, please contact us at support@nexgendigitalservices.lk</li>
        </ul>
      </div>
    </div>
  );
};

export default KidsZonePro;
